var _path, _mask, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeProfilePicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C8.10457 8 9 7.10457 9 6C9 4.89543 8.10457 4 7 4C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8Z",
    stroke: "#344868",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2238_29626",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 11H2C0.89543 11 0 10.1046 0 9V3.22222C0 2.11765 0.895431 1.22222 2 1.22222H3.65687C3.96032 0.504013 4.6713 0 5.5 0H8.5C9.3287 0 10.0397 0.504013 10.3431 1.22222H12C13.1046 1.22222 14 2.11765 14 3.22222V9C14 10.1046 13.1046 11 12 11H8.5H5.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65687 1.22222V2.22222H4.31996L4.57802 1.61142L3.65687 1.22222ZM10.3431 1.22222L9.42198 1.61142L9.68004 2.22222H10.3431V1.22222ZM5.5 10H2V12H5.5V10ZM2 10C1.44772 10 1 9.55229 1 9H-1C-1 10.6569 0.343146 12 2 12V10ZM1 9V3.22222H-1V9H1ZM1 3.22222C1 2.66994 1.44772 2.22222 2 2.22222V0.222222C0.343145 0.222222 -1 1.56537 -1 3.22222H1ZM2 2.22222H3.65687V0.222222H2V2.22222ZM4.57802 1.61142C4.73059 1.25033 5.08722 1 5.5 1V-1C4.25538 -1 3.19004 -0.242299 2.73571 0.833029L4.57802 1.61142ZM5.5 1H8.5V-1H5.5V1ZM8.5 1C8.91278 1 9.26941 1.25033 9.42198 1.61142L11.2643 0.833028C10.81 -0.242299 9.74462 -1 8.5 -1V1ZM10.3431 2.22222H12V0.222222H10.3431V2.22222ZM12 2.22222C12.5523 2.22222 13 2.66994 13 3.22222H15C15 1.56537 13.6569 0.222222 12 0.222222V2.22222ZM13 3.22222V9H15V3.22222H13ZM13 9C13 9.55228 12.5523 10 12 10V12C13.6569 12 15 10.6569 15 9H13ZM12 10H8.5V12H12V10ZM8.5 10H5.5V12H8.5V10Z",
    fill: "#344C73",
    mask: "url(#path-2-inside-1_2238_29626)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeProfilePicture);
export default __webpack_public_path__ + "static/media/change-profile-picture.a2ec4db76502bc370d20db6fa14b147b.svg";
export { ForwardRef as ReactComponent };